import { makeVar, useReactiveVar } from '@apollo/client';

type SetCanvasDraggable = (isCanvasDraggable: boolean) => void;

const isCanvasDraggableVar = makeVar<boolean>(true);

function setCanvasDraggable(isCanvasDraggable) {
  if (isCanvasDraggableVar() !== isCanvasDraggable) {
    isCanvasDraggableVar(isCanvasDraggable);
  }
}

export function useIsCanvasDraggableOperations(): {
  setCanvasDraggable: SetCanvasDraggable;
} {
  return { setCanvasDraggable };
}

export default function useIsCanvasDraggable(): [boolean, SetCanvasDraggable] {
  const isCanvasDraggable = useReactiveVar(isCanvasDraggableVar);

  return [isCanvasDraggable, setCanvasDraggable];
}
